// extracted by mini-css-extract-plugin
module.exports = {"textMargin":"WorkoutsUnsubscribeCompleted_textMargin__1xTNo","submitButton":"WorkoutsUnsubscribeCompleted_submitButton__2lqOS"};